import React from "react";
import Footer from "./Footer";

const WGUStory = () => {
  return (
    <>
    <div className="container">
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=League+Spartan:wght@100..900&family=Red+Hat+Text:ital,wght@0,300..700;1,300..700&display=swap"
        rel="stylesheet"
      ></link>

      <div className="pic">
        <img src="/pic.png" height="600px" alt="pic"/>
      </div>
      <p className="about-me">
        After spending a lot of time reading about every course in this degree
        on Reddit, I think it’s time to give back to the community. A little
        about me: I’m a 27-year-old Canadian citizen. I studied mechanical
        engineering in 2018 and earned a 2-year diploma in 2020—not a full
        degree. That’s when I first started coding, and I remember it being a
        lot of fun. I then found a job and gradually climbed the ladder in the
        mechanical field until early 2024. I had a well-paying senior position,
        but something was missing. Things were becoming repetitive in the
        mechanical field. Innovation was barely valued, and I’m an innovative
        person. It’s what I feed off of. So, I decided to finish my degree in
        mechanical engineering. It would take me another two years to complete
        where I left off, but I wanted something faster. After a lot of
        research, I stumbled upon WGU. After being skeptical for a long time and
        reading plenty of Reddit posts, I decided to pursue a degree in
        software. I remembered that I liked coding from school, and I felt like
        software is a field that is constantly developing and changing, which I
        enjoy.
      </p>
      <p className="about-me">
        WGU Journey: I decided to start in June, aiming to complete as many
        courses as I could on Sophia Learning before officially starting WGU. I
        enrolled for a September 1st start date. I transferred credits for 2
        courses from my mechanical engineering diploma (D339 and D324) and
        completed 10 courses on Sophia Learning: C458, C683, D322, D199, D957,
        C955, C963, D286, D335, and D270 in the order I passed them. I started
        on June 26th and finished on July 25th, putting in 55.07 hours.
      </p>

      <p className="about-me">
        I began WGU on September 1st, 2024, and finished on January 27th, 2025,
        completing 26 courses and 202.06 hours of studying, averaging about 10
        hours per week. I could have put in more hours, but I had a full-time
        job and was also running my side business at the same time. I’ve always
        been an active person, so I gave up on TV almost entirely over the past
        six months. However, I made time to game every night as a stress
        reliever. It is definitely doable, but it requires a lot of discipline.
        Trust me, there were days when I didn’t want to study, but you have to
        force yourself to do it, I repeat, force yourself. Until it becomes a
        habit. About 2.5 months in, I had a good idea of how quickly I could
        finish the course, and that motivated me. It’s just like working out—you
        start with no interest, force yourself every day, and then notice the
        results and start having fun.
      </p>
      <p className="about-me">
        My advice is to push yourself 5% past your limit each time, and you will
        improve! Keep in mind, I’ve always been the type of person who crams the
        night before a test and aces it. I tend to absorb information better
        under pressure. Different people have different strengths, so figure out
        what works for you and find the best way to study. (PLUS ULTRA!)
      </p>
      <p className="about-me">
        During this journey, I applied to a few software jobs, but I did it
        halfheartedly. I received two offers for junior positions, but I plan to
        be patient and wait for the right intermediate-level job that I know I
        would enjoy and not undervalue myself.
      </p>
      <p className="about-me">
        If you'd like to connect, feel free to add me here. If you need help
        with any of the courses, please message me on any of my Social Links
        below. If you’d like to follow my side business page{" "}
        <a href="https://www.instagram.com/kayc.automotive" target="_blank" rel="noreferrer">↗️</a>
        {" "}and support, I would appreciate that as well. Thank you for reading!
      </p>
    </div>
    <Footer/>
    </>
  );
};

export default WGUStory;
